import type { Metadata } from 'next';

import { generateListingMetadata } from '@/fo/util/listing-page';

import { loadBlogSearchParams } from './searchParams';

export async function generateBlogListingMetadata(options: {
  pathname: string;
  searchParams?: Promise<Record<string, string | string[] | undefined>>;
}): Promise<Metadata> {
  const raw = (await options.searchParams) ?? {};
  const { p } = await loadBlogSearchParams(raw);
  return generateListingMetadata({ pathname: options.pathname, page: p });
}
